const AcceptInvitation = () =>
  import("@/modules/externals/pages/AcceptInvitation.vue");

export default [
  {
    path: "/members/invite",
    name: "acceptInvitation",
    component: AcceptInvitation,
    meta: {
      guest: true,
    },
  },
];
